import { getImage, GatsbyImage } from "gatsby-plugin-image"
import { graphql } from "gatsby"
import React from "react"
import tw, { styled } from "twin.macro"
import Sandbox from "../atoms/sandbox"
import { themeStyles } from "../../styles/theme-helpers"

const ColumnImage = styled(GatsbyImage)`
  ${tw`rounded-full relative z-40`}
  max-width: 300px;
  img {
    ${tw`rounded-full`}
  }
`

const ColumnsSection = ({ data, titleXL }) => {
  const theme = data.theme?.name || "dark"
  return (
    <div
      tw="relative xxl:py-6"
      css={[themeStyles[theme]]}
      className={`tear-t-lg-${theme} tear-b-lg-${theme}`}
    >
      <div tw="relative max-w-screen-xl mx-auto py-6 md:pb-8 lg:pt-12 lg:pb-16">
        <p
          className="eyebrow"
          tw="text-sm text-center relative mt-1 pt-1 mb-6 sm:mb-10 lg:mb-8 lg:text-base xxl:mb-12"
        >
          {data.title}
        </p>
        <div tw="items-start justify-center flex-wrap sm:flex sm:px-6 xl:px-16">
          {data.column_content.map(item => (
            <div
              key={item.id}
              tw="w-full px-4 mb-8 xxs:px-6 sm:w-1/2 sm:px-3 md:w-1/3"
            >
              <Column data={item} titleXL={titleXL} />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

const Column = ({ data, titleXL }) => {
  const image = getImage(data.image?.localFile)
  return (
    <div tw="px-6 text-center">
      {image && (
        <ColumnImage
          className="half-tone"
          image={image}
          alt={data.image.alternativeText}
        />
      )}
      <div
        tw="bg-white text-brand-black  pb-8  relative xl:(pb-12)"
        css={[image ? tw`-mt-28 pt-36` : tw`pt-12`]}
        className="tear-t-sm-white tear-b-sm-white"
      >
        <h3
          tw="font-black font-display uppercase leading-none -mt-2 text-3xl xl:leading-none"
          css={titleXL ? "xl:text-5xl" : "px-4 xl:text-4xl"}
        >
          {data.title}
        </h3>
        {data.subtitle && <div tw="font-bold xl:text-lg">{data.subtitle}</div>}

        <Sandbox
          tw="px-6 text-sm mt-6 xl:px-12"
          dangerouslySetInnerHTML={{ __html: data.text }}
        />
      </div>
    </div>
  )
}

export const fragment = graphql`
  fragment ColumnsSection on FT_ComponentOrganismsColumnsSection {
    id
    title
    theme {
      name
    }
    column_content {
      id
      title
      subtitle
      text
      image {
        id
        url
        alternativeText
        localFile {
          childImageSharp {
            gatsbyImageData(
              aspectRatio: 1
              width: 320
              formats: [AUTO, WEBP, AVIF]
            )
          }
        }
      }
    }
  }
`

export default ColumnsSection
